import * as types from './mutations-types'

export default {
  [types.UPDATE_HEADER_HEIGHT](state, height) {
    state.headerHeight = height
  },
  [types.UPDATE_CONVERSATION_FOOTER_HEIGHT](state, height) {
    state.conversationFooterHeight = height
  },
  [types.SET_OVERLAY_OPEN](state, open) {
    state.overlayOpen = open
  },
  [types.SET_PARENT_SIZE](state, size) {
    state.parentSize = size
  }
}
